module.exports = __webpack_public_path__ + "static/media/financials.e0879e36.svg";